export default function About() {
  return (
    <div>

      {/* HERO SECTION */}
      <div className="hero">

        <div className="hero-content">

          <h1>Under Development</h1>

          <p className="hero-subtext">
            Under Development
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
          </p>

        </div>
	  
	  </div>
	
    </div>
  );
}
